type FormatDistance = (
  distance: number,
  distanceUnit: string,
  distanceMeasurement: string,
) => string;

// const normalizeDistanceMeasurement = (value: string): string => {
//   return value.replaceAll("_", " ").trim().toLowerCase();
// };

const normalizeDistanceMeasurement = (value?: string): string => {
  if (!value) return "";
  return value.replaceAll("_", " ").trim().toLowerCase();
};

/**
 * Format distance to a human-readable string.
 * @param distance
 * @param distanceUnit
 * @param distanceMeasurement
 * @returns Formatted distance string.
 */
export const formatDistance: FormatDistance = (
  distance,
  distanceUnit,
  distanceMeasurement,
) => {
  const normalizedDistanceMeasurement =
    normalizeDistanceMeasurement(distanceMeasurement);

  if (normalizedDistanceMeasurement === "city center") {
    return `${distance}${distanceUnit} from city center`;
  }
  return `${distance}${distanceUnit} from ${normalizedDistanceMeasurement}`;
};
